import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user : null
}

// Reducers must be pure — the previous version called `safeLogUserData(...)` inside the
// reducer body, which both violated Redux Toolkit's pure-reducer contract and logged the
// user object on every dispatch. If you need to observe auth changes for debugging, do it
// in middleware or in a React subscriber, not here.
export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserDetails : (state, action) => {
            state.user = action.payload
        }
    },
})

//Action creators are generated for each case reducer function
export const { setUserDetails } = userSlice.actions

export default userSlice.reducer